import script from "./StickersToolsBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./StickersToolsBackground.vue?vue&type=script&setup=true&lang=ts"

import "./StickersToolsBackground.vue?vue&type=style&index=0&id=19085175&lang=scss"

const __exports__ = script;

export default __exports__